import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

const coreBlue25 = ui.core[25];

export const challengesListCss: CSSObject = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  alignItems: "center",
  gap: "16px",
  width: "100%",
  justifyContent: "space-evenly",
  overflow: "visible",

  ".detailCard": {
    width: "100%",
    minWidth: "272px",
    borderRadius: "16px",
    backgroundColor: coreBlue25,
    transition: "box-shadow 0.3s ease-in-out",
    "&:hover": {
      cursor: "pointer",
      "-webkit-box-shadow": "0px 0px 13px 2px rgba(0,0,0,0.40)",
      "-moz-box-shadow": "0px 0px 13px 2px rgba(0,0,0,0.40)",
      "box-shadow": "0px 0px 13px 2px rgba(0,0,0,0.40)",
    },
  },
};
